import { Controller } from "@hotwired/stimulus";
import { debounce } from "../lib/utils";

export default class extends Controller {
  static targets = ["nav", "overflow", "toggle", "menu"];

  connect() {
    this.checkOverflow();
    window.addEventListener("resize", debounce(() => this.checkOverflow(), 200));
  }

  checkOverflow() {
    this.hideOverflowMenu();

    const containerWidth = this.navTarget.offsetWidth;
    const toggleWidth = this.getHiddenElementWidth(this.toggleTarget);

    const navLinks = this.navTarget.querySelectorAll(".nav-link");

    // Subtracting 1 from the initial total width fixes a chrome bug where the
    // last nav link is hidden when it should be visible
    let totalWidth = -1;

    let overflowItems = [];

    // Calculate the total width of all nav links and identify overflow items
    navLinks.forEach(link => {
      const style = window.getComputedStyle(link);
      const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);

      // The container width must exclude the toggle button for all but the last nav link
      let totalContainerWidth = containerWidth;
      if (link !== navLinks[navLinks.length - 1]) {
        totalContainerWidth -= toggleWidth;
      }

      totalWidth += link.offsetWidth + margin;
      if (totalWidth > totalContainerWidth) {
        overflowItems.push(link);
      }
    });

    if (overflowItems.length > 0) {
      this.showOverflowMenu(overflowItems);
    }
  }

  showOverflowMenu(overflowItems) {
    // Clear the current menu
    this.menuTarget.innerHTML = "";

    // Copy overflow nav-link items to the dropdown and hide the originals
    overflowItems.forEach(item => {
      const clonedNode = item.cloneNode(true);
      clonedNode.classList.remove("nav-link");
      clonedNode.classList.add("dropdown-item");
      this.menuTarget.appendChild(clonedNode);
      item.classList.add("d-none");
    });

    // Show the toggle button if hidden
    this.toggleTarget.classList.remove("d-none");
  }

  hideOverflowMenu() {
    // Get all current items in the dropdown
    const menuItems = this.menuTarget.querySelectorAll(".dropdown-item");

    menuItems.forEach(item => {
      const original = this.navTarget.querySelector(`[data-responsive-nav-id="${item.dataset.responsiveNavId}"]`);
      if (original) {
        // Show the original nav-link item
        original.classList.remove("d-none");
      }
    });

    // Hide the overflow menu
    this.menuTarget.innerHTML = "";
    this.toggleTarget.classList.add("d-none");
  }

  getHiddenElementWidth(element) {
    const clone = element.cloneNode(true);

    // Apply styles to ensure the element is rendered but not visible
    clone.style.visibility = "hidden";
    clone.style.position = "absolute";

    // Remove Bootstrap display classes
    clone.classList.remove("d-none");

    document.body.appendChild(clone);

    const width = clone.offsetWidth;

    document.body.removeChild(clone);

    return width;
  }
}

